import { render, staticRenderFns } from "./RsaScalaBarthelEditComponent.vue?vue&type=template&id=657c8195"
import script from "./RsaScalaBarthelEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaScalaBarthelEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports